import { GDFHotPolyHiRecordNormal } from '../../gdf/type';
import { getCopyButtonComponent } from '../copy-button';

export default function RaimProperties({ record }: { record: GDFHotPolyHiRecordNormal }) {
    const Button = getCopyButtonComponent();
    return (
        <div>
            <div>Details:</div>
            <pre className="secondary-bg-color p-2">{record.detail}</pre>
            {Button && (
                <div className="d-flex justify-content-start">
                    <Button getText={() => record.detail} />
                </div>
            )}
        </div>
    );
}
